export { default } from './widget.slice'
export * from './widget.slice'
